var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle-button button",class:{
    disabled: _vm.disabled,
    blue: _vm.blue,
    white: _vm.white,
    khaki: _vm.khaki,
    pink: _vm.pink,
    'pure-icon': _vm.pureIcon,
    'rounded-corner': _vm.roundedCorner
  },attrs:{"type":"button","title":_vm.pureIcon ? _vm.text : ''},on:{"click":_vm.onclick}},[(!_vm.pureIcon)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.hasIcon)?_vm._t("icon"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }